module.exports = __webpack_public_path__ + "img/check-footer-icon.ea1ee07e.svg";